import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { CreditcardState, initialCreditcardState } from './types'

export const creditcard: Module<CreditcardState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialCreditcardState),
  actions,
  getters,
  mutations,
}
